import { createFileRoute, useSearch } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { ResumeExperimentLoader } from '~/features/experiments/components/create-experiment/resume-experiment-loader';

const CreateExperimentConfigurePage = lazy(
  () => import('~/features/experiments/pages/create-experiment-configure-page'),
);

/**
 * Search schema for the configure page. `expId` is the only param — when
 * present, the route hydrates the wizard from the corresponding draft via
 * `<ResumeExperimentLoader>`. Absent / empty → fresh-create flow.
 */
const searchSchema = z.object({
  expId: z.string().min(1).optional(),
});

/** `/experiments/create/configure` — Step 3: the 5-step experiment wizard. */
export const Route = createFileRoute('/_authenticated/_tenant/experiments_/create/configure')({
  validateSearch: searchSchema,
  component: ConfigureRoute,
});

function ConfigureRoute() {
  const { expId } = useSearch({
    from: '/_authenticated/_tenant/experiments_/create/configure',
  });
  return (
    <ResumeExperimentLoader expId={expId}>
      <Suspense fallback={<PageSkeleton />}>
        <CreateExperimentConfigurePage />
      </Suspense>
    </ResumeExperimentLoader>
  );
}
